// @flow

import type { AssetOperation } from 'fc-operator-asset/types'
import _head from 'lodash/head'

// Libs
import React, { Component } from 'react'

// Utils
import traverse from 'fc-utils/traverse'

// Components
import { Errors } from 'hfty-components-errors'
import { messages } from 'fc-assets'

// Constants
import { FARM, FIELD, PROP_LABEL, PROP_PARENT, PROP_CATEGORY, PROP_SEASON } from 'fc-model-assets'

// Constants
import { ADD, DELETE, EDIT } from './../constants'

// Components
import Textfield from '@react-mdc/textfield'
import Radio from '@react-mdc/radio'
import FormField from '@react-mdc/form-field'
import Select from 'react-select'

// Getters
const getLabel = traverse(['operation', 'model', PROP_LABEL], { default: '' })
const getCategory = traverse(['operation', 'model', PROP_CATEGORY], { default: '' })
const getParent = traverse(['operation', 'model', PROP_PARENT], { default: '' })
const getSeason = traverse(['operation', 'model', PROP_SEASON], { default: '' })

// Styles
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
}

type Props = {
  operation: AssetOperation,
  farmSelectorOptions: Array<{ value: number, label: string }>,
  seasonSelectorOptions: Array<{ value: number, label: string }>,
  growerId: number,
  onChange: Function,
  selectedFarmId: number,
}

export default class EditAsset extends Component {
  props: Props
  onChangeLabel: Function
  onChangeFarm: Function
  onChangeSeason: Function
  onChangeCategory: Function

  constructor (props: Props) {
    super(props)

    this.onChangeLabel = this.onChangeLabel.bind(this)
    this.onChangeFarm = this.onChangeFarm.bind(this)
    this.onChangeSeason = this.onChangeSeason.bind(this)
    this.onChangeCategory = this.onChangeCategory.bind(this)
  }

  onChangeLabel (e: Event & { currentTarget: HTMLInputElement }) {
    this.props.onChange({
      ...this.props.operation,
      model: {
        [PROP_LABEL]: e.currentTarget.value,
      },
    })
  }

  onChangeFarm ({ value }: { value: number }) {
    this.props.onChange({
      ...this.props.operation,
      model: {
        [PROP_PARENT]: value,
      },
    })
  }

  onChangeSeason ({ value }: { value: number }) { // eslint-disable-line react/no-unused-prop-types
    this.props.onChange({
      ...this.props.operation,
      model: {
        [PROP_SEASON]: value,
      },
    })
  }

  onChangeCategory (e: Event & { currentTarget: HTMLInputElement }) {
    const category = e.currentTarget.value

    this.props.onChange({
      ...this.props.operation,
      model: {
        [PROP_CATEGORY]: category,
        [PROP_PARENT]:
        category === FARM ? this.props.growerId : traverse([_head, 'value'])(this.props.farmSelectorOptions),
      },
    })
  }

  render (): React.Element<any> {
    const { operation } = this.props
    const isAdding = operation.operation === ADD
    const isEditing = operation.operation === EDIT
    const isDeleting = operation.operation === DELETE
    const isField = getCategory(this.props) === FIELD
    const isFarm = getCategory(this.props) === FARM
    const showDropDown = (isEditing || isAdding || isDeleting) && isField
    const showSeasonSelector = isAdding || !operation.model.id
    const hasErrors = operation && operation.errors
    const farmSelector = (
      <FormField key='farm-selector'>
        <label htmlFor='farm-selector'>Farm</label>
        <Select
          disabled={isDeleting}
          name='farm-selector'
          placeholder={'Farm'}
          value={isAdding && isFarm ? this.props.selectedFarmId || getParent(this.props) : getParent(this.props)}
          options={this.props.farmSelectorOptions}
          onChange={this.onChangeFarm}
        />
      </FormField>
    )
    const seasonSelector = (
      <FormField key='season-selector'>
        <label htmlFor='season-selector'>Season</label>
        <Select
          disabled={isDeleting}
          name='season-selector'
          placeholder={'Seasons'}
          value={getSeason(this.props)}
          options={this.props.seasonSelectorOptions}
          onChange={this.onChangeSeason}
        />
      </FormField>
    )

    return (
      <div style={styles.container}>
        <FormField>{hasErrors && <Errors errors={operation.errors} messages={messages} />}</FormField>
        {isAdding && (
          <FormField>
            <Radio.Default
              id='category.field'
              name='category'
              value={FIELD}
              checked={getCategory(this.props) === FIELD}
              onChange={this.onChangeCategory}
            />
            <label htmlFor='category.field'>Field</label>
            <Radio.Default
              id='farm'
              name='category'
              value={FARM}
              checked={getCategory(this.props) === FARM}
              onChange={this.onChangeCategory}
            />
            <label htmlFor='category.farm'>Farm</label>
          </FormField>
        )}
        {/* EDIT / DELETE */}
        {showDropDown && [farmSelector, showSeasonSelector && seasonSelector]}
        <FormField>
          <Textfield disabled={operation.submitting}>
            <Textfield.Input
              disabled={isDeleting}
              id={`label-${operation.operationId}`}
              value={getLabel(this.props)}
              onChange={this.onChangeLabel}
            />
            <Textfield.Label htmlFor='usage-1'>{getCategory(this.props)}</Textfield.Label>
          </Textfield>
        </FormField>
      </div>
    )
  }
}
